import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfiguratorIntegrations } from '@models';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';
import { environment } from '@environments/environment';

export interface GetIntegrationsParams extends DefaultHttpHeaders {}

@Injectable()
export class GetIntegrationsService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  getIntegrations(params: GetIntegrationsParams): Observable<ConfiguratorIntegrations> {
    return this.get<ConfiguratorIntegrations>({
      suffix: '/configurator/integrations',
      apiUrl: environment.configuratorApiUrl,
    });
  }
}
